import { transparentize as e } from "@chakra-ui/theme-tools";
import o from "./foundations/colors.mjs";
const r = (a, i) => e(a, i)({ colors: o }), n = {
  colors: {
    "chakra-body-text": { _light: "gray.900", _dark: "whiteAlpha.900" },
    "chakra-body-bg": { _light: "warmGray.50", _dark: "cold" },
    "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
    "chakra-inverse-text": { _light: "white", _dark: "gray.900" },
    "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
    "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
    "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" },
    "action.50": "indigo.50",
    "action.100": "indigo.100",
    "action.200": "indigo.200",
    "action.300": "indigo.300",
    "action.400": "indigo.400",
    "action.500": "indigo.500",
    "action.600": "indigo.600",
    "action.700": "indigo.700",
    "action.800": "indigo.800",
    "action.900": "indigo.900",
    "error.50": "red.50",
    "error.100": "red.100",
    "error.200": "red.200",
    "error.300": "red.300",
    "error.400": "red.400",
    "error.500": "red.500",
    "error.600": "red.600",
    "error.700": "red.700",
    "error.800": "red.800",
    "error.900": "red.900",
    "warning.50": "orange.50",
    "warning.100": "orange.100",
    "warning.200": "orange.200",
    "warning.300": "orange.300",
    "warning.400": "orange.400",
    "warning.500": "orange.500",
    "warning.600": "orange.600",
    "warning.700": "orange.700",
    "warning.800": "orange.800",
    "warning.900": "orange.900",
    background: "#f6f4f2",
    surface: {
      default: "white",
      _dark: "gray.900"
    },
    demoLabel: {
      default: "blackAlpha.300",
      _dark: "whiteAlpha.300"
    },
    "demoLabel.highContrast": {
      default: "blackAlpha.900",
      _dark: "whiteAlpha.900"
    },
    //#region old odi tokens
    "onSurface.highEmphasis": "cold",
    //@deprecated
    "onSurface.layoutHelperDark": "coldAlpha.800",
    "onSurface.mediumEmphasis": "gray.500",
    "onSurface.lowEmphasis": "coldAlpha.500",
    //@deprecated
    "onSurface.layoutHelperLight": "coldAlpha.300",
    "onSurface.layoutHelper": "coldAlpha.300",
    "primary.highEmphasis": "cold",
    "primary.mediumEmphasis": "gray.500",
    "primary.lowEmphasis": "coldAlpha.500",
    "onPrimary.highEmphasis": "white",
    "onPrimary.mediumEmphasis": "whiteAlpha.700",
    "onPrimary.lowEmphasis": "whiteAlpha.500",
    "onPrimary.layoutHelper": "whiteAlpha.300",
    "secondary.highEmphasis": "primary.500",
    "secondary.mediumEmphasis": r("primary.500", 0.64),
    "secondary.lowEmphasis": r("primary.500", 0.36),
    "secondary.layoutHelper": r("primary.500", 0.12),
    "onSecondary.highEmphasis": "white",
    "onSecondary.mediumEmphasis": "whiteAlpha.700",
    "onSecondary.lowEmphasis": "whiteAlpha.500",
    "tertiary.highEmphasis": "caribbeanGreen.500",
    "tertiary.mediumEmphasis": r("caribbeanGreen.500", 0.64),
    "tertiary.lowEmphasis": r("caribbeanGreen", 0.36),
    "onTertiary.highEmphasis": "white",
    "onTertiary.mediumEmphasis": "whiteAlpha.700",
    "onTertiary.lowEmphasis": "whiteAlpha.500",
    "success.highEmphasis": "lime.500",
    "success.mediumEmphasis": r("lime.500", 0.64),
    "success.lowEmphasis": r("lime.500", 0.36),
    "onSuccess.highEmphasis": "cold",
    "onSuccess.mediumEmphasis": "coldAlpha.700",
    "onSuccess.lowEmphasis": "coldAlpha.500",
    "error.highEmphasis": "red.500",
    "error.mediumEmphasis": r("red.500", 0.6),
    "error.lowEmphasis": r("red.500", 0.36),
    "error.layoutHelper": r("red.500", 0.12),
    "onError.highEmphasis": "white",
    "onError.mediumEmphasis": "whiteAlpha.700",
    "onError.lowEmphasis": "whiteAlpha.500",
    "warning.highEmphasis": "orange.500",
    "warning.mediumEmphasis": r("orange.500", 0.64),
    "warning.lowEmphasis": r("orange.500", 0.36),
    "onWarning.highEmphasis": "cold",
    "onWarning.mediumEmphasis": "coldAlpha.700",
    "onWarning.lowEmphasis": "coldAlpha.500",
    "statesOverlay.pressed": "coldAlpha.300",
    "statesOverlay.inverted.pressed": "whiteAlpha.300"
    //#endregion
  },
  sizes: {
    headerHeight: "14"
  }
};
export {
  n as semanticTokens
};
